'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const fastdom=require('fastdom');

const DefaultServiceParams={
_axisDirective:null,
scheduleRowDirectives:new Set,
_scheduleScrollClasses:{"right-scrollable":!1,"left-scrollable":!1}};


const DayInMs=8.64e7;
const DefaultWindowSizeInDays=14;
const MaxWindowSizeInDays=14;
const MinWindowSizeInDays=14;let

ScheduleRowScrollingService=function(_BaseService){_inherits(ScheduleRowScrollingService,_BaseService);
function ScheduleRowScrollingService($rootScope){_classCallCheck(this,ScheduleRowScrollingService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._$rootScope=$rootScope;

_.defaults(_this,DefaultServiceParams);return _this;
}ScheduleRowScrollingService.prototype.

_updateScheduleScrollClasses=function _updateScheduleScrollClasses(){
this._scheduleScrollClasses['right-scrollable']=this._axisDirective.axisBounds.end.getTime()>this._axisDirective.currentBounds.end.getTime();
this._scheduleScrollClasses['left-scrollable']=this._axisDirective.axisBounds.start.getTime()<this._axisDirective.currentBounds.start.getTime();
};ScheduleRowScrollingService.prototype.





setAxis=function setAxis(scheduleRowAxisDirective){
this._axisDirective=scheduleRowAxisDirective;
};ScheduleRowScrollingService.prototype.

registerScheduleRowDirective=function registerScheduleRowDirective(directive){
this.scheduleRowDirectives.add(directive);
};ScheduleRowScrollingService.prototype.

unregisterScheduleRowDirective=function unregisterScheduleRowDirective(directive){
this.scheduleRowDirectives.delete(directive);
};ScheduleRowScrollingService.prototype.

updateScheduleWindows=function(){var ref=_asyncToGenerator(function*(){var _this2=this;let throttledUpdateTimeInMs=arguments.length>0&&arguments[0]!==void 0?arguments[0]:0;
const windowUpdateOptions=throttledUpdateTimeInMs!==0?
{animation:{duration:throttledUpdateTimeInMs,easingFunction:'linear'}}:
{animation:!1};

for(const scheduleRow of this.scheduleRowDirectives){
scheduleRow._updateWindow(this.axisBounds,windowUpdateOptions);
}

yield new Promise(function(resolve){
_this2._$rootScope.$evalAsync(function(){
_this2._updateScheduleScrollClasses();
resolve();
});
});
});function updateScheduleWindows(){let throttledUpdateTimeInMs=arguments.length>0&&arguments[0]!==void 0?arguments[0]:0;return ref.apply(this,arguments)}return updateScheduleWindows}();ScheduleRowScrollingService.prototype.

updateScheduleRowOptions=function updateScheduleRowOptions(newOptions){
for(const scheduleRow of this.scheduleRowDirectives){
scheduleRow._updateOptions(newOptions);
}
};_createClass(ScheduleRowScrollingService,[{key:'scheduleScrollClasses',get:function(){return this._scheduleScrollClasses}},{key:'axisBounds',get:function()

{
if(!_.exists(this._axisDirective)){
throw new Error('No axis registered!');
}

return this._axisDirective.currentBounds;
}},{key:'defaultWindowSizeInMilliseconds',get:function()

{
return DefaultWindowSizeInDays*DayInMs;
}},{key:'maxWindowSizeInMilliseconds',get:function()

{
return MaxWindowSizeInDays*DayInMs;
}},{key:'minWindowSizeInMilliseconds',get:function()

{
return MinWindowSizeInDays*DayInMs;
}}]);return ScheduleRowScrollingService}(BaseService);


module.exports=ScheduleRowScrollingService;
//# sourceMappingURL=scheduleRowScrollingService.js.map
